import { OutbrainTracker } from '@buzzfeed/third-party-analytics';
import { CLUSTER, outbrain_ids } from '../../../constants';
import cookies from '@buzzfeed/buzzblocks/js/services/cookies';

let trackingInstance;

const ob = () => {
  if (!trackingInstance) {
    trackingInstance = new OutbrainTracker({
      cluster: CLUSTER,
      ids: outbrain_ids,
    });
  }
  return trackingInstance;
};

export async function trackOutbrainPageView() {
  if (cookies.get('bf-geo-country') === 'JP') {
    const tracker = ob();
    tracker.trackPageView();
  }
}

export async function trackOutbrainAffiliateClick() {
  if (cookies.get('bf-geo-country') === 'JP') {
    const tracker = ob();
    tracker.trackAffiliateClick();
  }
}
